import Accordion from 'accordion-js';
import device from './device';

const table = () => {
  if (device.touch() || !device.desktop()) {
    const accordions = document.querySelectorAll('.c-table__wrapper');
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < accordions.length; i++) {
      const options = {};

      options.elementClass = 'c-table__item';
      options.questionClass = 'c-table__item__title';
      options.answerClass = 'c-table__item__content';

      // eslint-disable-next-line no-unused-vars
      const accordionInstance = new Accordion(`#${accordions[i].id}`, options);
    }
  }
};

export default table;



// WEBPACK FOOTER //
// ./public/wp-content/themes/druckhaus/src/scripts/modules/table.js